import { render } from "./ResetPasswordVerification.vue?vue&type=template&id=2007eddb&scoped=true"
import script from "./ResetPasswordVerification.vue?vue&type=script&lang=js"
export * from "./ResetPasswordVerification.vue?vue&type=script&lang=js"

import "./ResetPasswordVerification.vue?vue&type=style&index=0&id=2007eddb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2007eddb"]])

export default __exports__